var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "text-muted mb-1" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                "Deixe a abertura e o fechamento vazios para indicar que a loja fica fechada no dia."
              )
            ) +
            " "
        ),
      ]),
      _c(
        "b-row",
        {
          staticClass:
            "d-none d-md-flex text-muted font-small-3 font-weight-bold mb-25",
        },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _vm._v(" " + _vm._s(_vm.$t("Dia")) + " "),
          ]),
          _c("b-col", { attrs: { md: "3" } }, [
            _vm._v(" " + _vm._s(_vm.$t("Abre")) + " "),
          ]),
          _c("b-col", { attrs: { md: "3" } }, [
            _vm._v(" " + _vm._s(_vm.$t("Fecha")) + " "),
          ]),
          _c("b-col", { attrs: { md: "3" } }),
        ],
        1
      ),
      _vm._l(_vm.days, function (day) {
        return _c(
          "b-row",
          {
            key: day.dayOfWeek,
            staticClass: "opening-hours-row",
            attrs: { "align-v": "center" },
          },
          [
            _c("b-col", { staticClass: "mb-50 mb-md-0", attrs: { md: "3" } }, [
              _c("strong", [_vm._v(_vm._s(_vm.dayLabel(day.dayOfWeek)))]),
            ]),
            _c(
              "b-col",
              { attrs: { md: "3" } },
              [
                _c("FormulateInput", {
                  staticClass: "mb-0",
                  attrs: {
                    id: "opening-" + day.dayOfWeek + "-start",
                    type: "text-mask",
                    mask: ["##:##"],
                    name: "opening_" + day.dayOfWeek + "_start",
                    placeholder: "--:--",
                  },
                  model: {
                    value: day.openingTime,
                    callback: function ($$v) {
                      _vm.$set(day, "openingTime", $$v)
                    },
                    expression: "day.openingTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { attrs: { md: "3" } },
              [
                _c("FormulateInput", {
                  staticClass: "mb-0",
                  attrs: {
                    id: "opening-" + day.dayOfWeek + "-end",
                    type: "text-mask",
                    mask: ["##:##"],
                    name: "opening_" + day.dayOfWeek + "_end",
                    placeholder: "--:--",
                  },
                  model: {
                    value: day.closingTime,
                    callback: function ($$v) {
                      _vm.$set(day, "closingTime", $$v)
                    },
                    expression: "day.closingTime",
                  },
                }),
              ],
              1
            ),
            _c("b-col", { staticClass: "mb-50 mb-md-0", attrs: { md: "3" } }, [
              _vm.isClosed(day)
                ? _c("span", { staticClass: "text-muted font-small-2" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Fechado")) + " "),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }